<style scoped>
.iframe-sty {
    width: 100%;
    border: none;
    height: 600px;

}

.flow {
    background: #fff;
    padding-left: 20px;
    margin-top: 4px;
}

.pdt100 {
    padding-bottom: 100px !important;
}

.header {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;

}

.header .back {
    background: #FFFFFF;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
}

.import-title {
    text-align: left;
    background: #fff;
    padding: 10px 16px;
    font-size: 16px;
    padding-bottom: 0;
}

.import-title.second {
    margin-top: 4px;
}

.header .title {
    text-align: center;
    flex: 1;
}

.customer-information {
    background: #fff;
    padding: 15px;
}

.customer-information .sub-title {
    text-align: left;
    font-size: 14px;
    padding: 10px 16px;
}

.sub-operate-add {
    color: #4FA1A4;
    margin-left: 14px;
    cursor: pointer;

}

.customer-information .cols {
    background: #fff;
    display: flex;
    padding: 8px 16px;
    padding-left: 20px;
}

.customer-information .col-itms {
    display: flex;
    align-items: center;
    margin-left: 20px;
}

.customer-information .col-itms .title {
    width: 80px;
    text-align: right;
    margin-right: 10px;
}

.customer-information .col-itms.second {
    align-items: flex-start;
}

.customer-information .col-itms .title span {
    color: red;
}

.import-new-wrap {
    padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
    text-align: left;
    padding-left: 170px;

}

.import-new-wrap .col-itms {
    align-items: baseline;
}

.operte-btns {
    background: #fff;
    margin-top: 4px;
    display: flex;
    justify-content: center;
    padding: 25px 0;

}

.operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;

}

.operte-btns .btn.save {

    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
}

.operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;

}

.content-main-box {
    height: auto !important;
}

.search-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.search-wrap .input-search {
    width: 200px;
}

.empty-btns {
    justify-content: flex-start;
    margin-left: 130px;
    padding-top: 0;
}

.add-ziduan {
    display: flex;
    justify-content: space-between;
}

.add-ziduan .btn {
    color: #4FA1A4;
    border: 1px solid rgba(79, 161, 164, 1);
    border-radius: 2px;
    width: 64px;
    height: 28px;
    font-size: 12px;
    text-align: center;
    line-height: 28px;
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
}


.el-table /deep/ .el-input__inner {
    height: 28px;
    line-height: 28px;
}

.el-range-editor.el-input__inner {
    padding: 0px;
}

/deep/ .el-checkbox__label {
    display: none;
}

.check-table-input .el-input__inner {
    text-align: right !important;
}

.rate-box {
    display: flex;
    align-items: center;
    justify-content: space-around;

}
</style>

<template>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="header">
            <div class="back" @click="$router.go(-1)">返回</div>
            <div class="title">配置数据映射</div>
        </div>
        <div class="import-title">配置数据映射</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>业务功能：</div>
                    <el-select v-model="funcGuid" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in functionList" :key="item.guid"
                            :label="item.functionName + '-' + item.functionCode" :value="item.guid"></el-option>
                    </el-select>
                </div>

            </div>
            <div class="cols">
                <div class="col-itms second">
                    <div class="title"><span>*</span>快捷添加：</div>
                    <el-input rows="4" resize="none" class="w500" type="textarea" maxlength="200" placeholder="请填写"
                        v-model="codeTxt"></el-input>
                </div>
            </div>
            <div class="operte-btns empty-btns">
                <div class="btn cancel" @click="$router.go(-1)">清空</div>
                <div class="btn submit" @click="saveReq">转换</div>
            </div>
        </div>
        <div class="import-title add-ziduan" style="margin-top:4px;">
            <span class="title">单个添加</span>
            <div class="btns">
                <span class="btn" @click="addFirsItem">新增子集</span>
            </div>
        </div>
        <div class="customer-information content-main-box">
            <!-- start of table -->
            <el-table :data="tableData" default-expand-all :tree-props="{ children: 'mapping' }" stripe row-key="guid"
                style="width: 100%" v-loading="tableLoading" :height="height">
                <el-table-column label="序号" width="100" header-align="center" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.index }}
                    </template>
                </el-table-column>
                <el-table-column label="源字段" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-input size="mini" placeholder="请填写" v-model="scope.row.sourceKey" />
                    </template>
                </el-table-column>
                <el-table-column label="源字段名称" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-input size="mini" placeholder="请填写" v-model="scope.row.sourceName" />
                    </template>
                </el-table-column>

                <el-table-column label="源字段类型" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-select size="mini" filterable v-model="scope.row.sourceType" placeholder="请选择">
                            <el-option v-for="(item, index) in scope.row.sourceTypeList" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="目标库名" width="120" header-align="center" align="center">

                    <template slot-scope="scope">
                        <!-- <span  v-if="scope.row.isRoot">-</span> -->
                        <el-input size="mini" placeholder="请填写" v-model="scope.row.targetDatabase" />
                    </template>
                </el-table-column>

                <el-table-column label="目标表名" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-input size="mini" placeholder="请填写" v-model="scope.row.targetTable" />
                    </template>
                </el-table-column>
                <el-table-column label="目标字段" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-input size="mini" placeholder="请填写" v-model="scope.row.targetValue" />
                    </template>
                </el-table-column>
                <el-table-column label="目标字段类型" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-select size="mini" filterable v-model="scope.row.targetType" placeholder="请选择">
                            <el-option v-for="(item, index) in scope.row.sourceTypeList" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="显示类型" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-select @change="scope.row.dictGuid=null" clearable size="mini" filterable v-model="scope.row.displayType" placeholder="请选择">
                            <el-option v-for="(item, index) in displayTypeList" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="平台字典" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-select :disabled="scope.row.displayType != 'dropdown' && scope.row.displayType != 'dropdownlist' && scope.row.displayType != 'basedate'"
                                clearable size="mini" filterable v-model="scope.row.dictGuid" placeholder="请选择">
                                <template v-if="scope.row.displayType == 'dropdown'||scope.row.displayType == 'dropdownlist'">
                                <el-option v-for="(item, index) in dictGuidList" :key="index" :label="item.dictTypeName"
                                    :value="item.guid"></el-option>
                                </template>
                                <template v-if="scope.row.displayType == 'basedate'">
                                    <el-option v-for="(item, index) in baseDataList" :key="index" :label="item.label"
                                        :value="item.value"></el-option>
                                </template>
                        
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="界面排序" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-input type="number" :min="1" placeholder="请填写" size="mini" v-model="scope.row.sortNum" />
                    </template>
                </el-table-column>
                <el-table-column label="是否组名" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <!-- <span  v-if="scope.row.isRoot">-</span> -->
                        <el-select size="mini" filterable v-model="scope.row.groupFlag" placeholder="请选择">
                            <el-option v-for="(item, index) in [{ label: '是', value: 1 }, { label: '否', value: 0 }]"
                                :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="是否展示" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <!-- <span  v-if="scope.row.isRoot">-</span> -->
                        <el-select size="mini" filterable v-model="scope.row.displayFlag" placeholder="请选择">
                            <el-option v-for="(item, index) in [{ label: '是', value: 1 }, { label: '否', value: 0 }]"
                                :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="是否主键" width="120" header-align="center" align="center">
                    <template slot-scope="scope">
                        <!-- <span  v-if="scope.row.isRoot">-</span> -->
                        <el-select size="mini" filterable v-model="scope.row.keyFlag" placeholder="请选择">
                            <el-option v-for="(item, index) in [{ label: '是', value: 1 }, { label: '否', value: 0 }]"
                                :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>

                <el-table-column label="操作" min-width="150" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isRoot" type="text" size="mini"
                            @click="addSecondItem(scope.row.guid)">新增字段</el-button>
                        <el-button type="text" size="mini" @click="delItem(scope.row)">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <!-- end of table -->
        </div>
        <div class="operte-btns">
            <div class="btn cancel" @click="$router.go(-1)">取消</div>

            <div class="btn submit" @click="saveReq">确定</div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            fullscreenLoading: false,
            guid: null,
            height: window.innerHeight - 280,
            tableLoading: false,
            targetTypeList: [ //目标字段类型
                { label: "整型", value: "integer" },
                { label: "浮点型", value: "decimal" },
                { label: "字符型", value: "char" },
                { label: "字符串型", value: "string" },
                { label: "布尔型", value: "boolean" },
                { label: "日期型", value: "date" },
            ],
            sourceTypeList: [ //源字段类型
                { label: "集合", value: "array" },
                { label: "对象", value: "object" }
            ],
            displayTypeList: [ //显示类型集合
                { label: "文本", value: "input" },
                { label: "多行文本", value: "text" },
                { label: "单选", value: "dropdown" },
                { label: "多选", value: "dropdownlist" },
                { label: "文件", value: "file" },
                { label: "日期型", value: "date" },
                { label: "省市区", value: "areaselect" },
                { label: "基础数据", value: "basedate" },
            ],
            dictGuidList: JSON.parse(localStorage.codeList),//字典集合
            baseDataList: [],
            tableData: [
            ],
            codeTxt: '',
            funcGuid: this.$route.query.functionGuid,
            functionList: [],
            delList: [] //删除的子集

        }
    },
    computed: {
    },
    created() {
        this.getFunctionList();
        this.getDetail();
        this.getBaseDataList();
    },
    methods: {
        //获取基础数据
        getBaseDataList() {
            this.fullscreenLoading = true;
            this.api.postJson(`/${serverConfig.msConfigureService}/basic-info/list-titles`).then((res) => {
                this.fullscreenLoading = false;
                this.basedateList = [];
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    for (let key in res.data.data) {
                        this.baseDataList.push({
                            label:res.data.data[key],
                            value:key
                        })
                    }
                    console.log(this.baseDataList)
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },

        //新增子集
        addFirsItem() {
            let firstItem = {
                "guid": this.generateUUID(),
                "sourceKey": null,//源字段或主键
                "sourceName": null,//源字段名称
                "sourceType": null,//源字段类型
                "targetType": null,//目标字段类型
                "targetTable": null,//目标表名
                "targetValue": null,//目标字段
                "targetDatabase": null,//目标库名
                "keyFlag": 0,//是否主键
                "displayFlag": 1,//是否展示
                "groupFlag": 1,//是否组名
                "sortNum": null,//界面排序
                "dictGuid": null,//字典表guid,

                "displayType": 'input',//显示类型
                "mapping": [],
                "sourceTypeList": [ //集合
                    { label: "集合", value: "array" },
                    { label: "对象", value: "object" }
                ],
                "isRoot": true,
                "index": this.tableData.length + 1,
            }

            this.tableData.push(firstItem);
        },
        //新增字段
        addSecondItem(guid) {
            let tableData = this.tableData;
            let secondItem = {
                "guid": this.generateUUID(),
                "sourceKey": null,//源字段或主键
                "sourceName": null,//源字段名称
                "sourceType": null,//源字段类型
                "targetType": null,//目标字段类型
                "targetTable": null,//目标表名
                "targetValue": null,//目标字段
                "targetDatabase": null,//目标库名
                "keyFlag": 0,//是否主键
                "sortNum": null,//界面排序
                "groupFlag": 0,//是否组名
                "displayFlag": 1,//是否展示
                "dictGuid": null,//字典表guid,
                "displayType": 'input',//显示类型

                "sourceTypeList": [ //集合
                    { label: "整型", value: "integer" },
                    { label: "浮点型", value: "decimal" },
                    { label: "字符型", value: "char" },
                    { label: "字符串型", value: "string" },
                    { label: "布尔型", value: "boolean" },
                    { label: "日期型", value: "date" },
                ],
                "targetDatabase": null,//目标库名
                "keyFlag": 0,//是否主键
                "isRoot": false,
                "index": 0
            }
            tableData.forEach((item, index) => {
                if (item.guid == guid) {
                    secondItem.index = index + 1;
                    item.mapping.push(secondItem);
                }
            })
            this.tableData = tableData;
        },
        //删除
        delItem(obj) {
            let isRoot = obj.isRoot;
            let guid = obj.guid;
            let index = obj.index;
            let tableData = this.tableData;
            if (isRoot) {
                tableData.forEach((i, j) => {
                    if (i.guid == guid) {
                        tableData.splice(j, 1)
                    }
                })
                if (guid.indexOf('test_') == -1 && this.$route.query.guid) {
                    this.delList.push({
                        "guid": guid,
                        "optFlag": 'Delete',
                        "sourceKey": obj.sourceKey,//源字段或主键
                        "sourceName": obj.sourceName,//源字段名称
                        "sourceType": obj.sourceType,//源字段类型
                        "targetType": obj.targetType,//目标字段类型
                        "targetTable": obj.targetTable,//目标表名
                        "targetValue": obj.targetValue,//目标字段
                        "targetDatabase": obj.targetDatabase,//目标库名
                        "keyFlag": obj.keyFlag,//是否主键
                        "sortNum": null,//界面排序
                        "groupFlag": 0,//是否组名
                        "displayFlag": 1,//是否展示
                        "displayType": obj.displayType,//显示类型
                        "dictGuid": obj.dictGuid,//字典表guid
                        "mapping": JSON.stringify(obj.mapping)
                    })
                }
            } else {
                tableData.forEach((m, n) => {
                    if ((n + 1) == index) {
                        console.log(m.mapping)
                        m.mapping.forEach((j, k) => {
                            if (j.guid == guid) {
                                m.mapping.splice(k, 1)
                            }
                        })
                    }
                })
            }
            this.tableData = tableData;
        },
        //生成guid
        generateUUID() {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === "function") {
                d += performance.now(); //use high-precision timer if available
            }
            var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return 'test_' + uuid;
        },
        //保存/更新
        saveReq() {
            if (!this.checkForm()) return;
            let reqUrl = `/${serverConfig.msConfigureService}/rosterplatform/func-datamapping-config/createOrUpdateFuncDatamappingConfig`
            let mfParamsMappingList = JSON.parse(JSON.stringify(this.tableData));
            let guid = this.$route.query.guid || null;
            let req = null;
            mfParamsMappingList.forEach(j => {
                j.mapping.forEach(m => {
                    delete m.guid;
                    delete m.sourceTypeList;
                    delete m.index;
                    delete m.isRoot;
                })
                if (j.guid.indexOf('test_') > -1) {
                    delete j.guid;
                    j.optFlag = 'Create' //新增
                } else {
                    j.optFlag = 'Update' //更新
                }
                delete j.sourceTypeList;
                delete j.index;
                delete j.isRoot;
                j.mapping = JSON.stringify(j.mapping);
            })
            req = {
                'operationTime': new Date(this.$moment(new Date).format('YYYY-MM-DD HH:mm:ss')),
                'effective': 1,//是否启用
                'funcGuid': this.funcGuid,//功能guid
                'mfParamsMappingList': mfParamsMappingList,
                "guid": guid
            }
            if (guid && this.delList.length) {
                req.mfParamsMappingList = req.mfParamsMappingList.concat(this.delList);
            }
            if (!this.checkKeyOnly(req.mfParamsMappingList)) return;;
            this.fullscreenLoading = true;
            this.api.postJson(reqUrl, req).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.$message({
                        message: guid ? '修改成功' : '新增成功',
                        type: 'success',
                    });
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        checkKeyOnly(list) {
            let flag = true;
            for (let i = 0; i < list.length - 1; i++) {
                for (let j = i + 1; j < list.length; j++) {
                    if (list[i].keyFlag && (list[i].targetDatabase == list[j].targetDatabase) && (list[i].keyFlag == list[j].keyFlag) && (list[i].targetTable == list[j].targetTable)) {
                        this.$message({
                            message: '同一个目标库同一个目标表只能设定一个主键!',
                            type: 'error'
                        });
                        flag = false;
                    }
                }
            }
            return flag;
        },
        checkForm() {
            try {
                if (!this.funcGuid) {
                    throw new Error('业务功能不能为空');
                }
                if (!this.tableData.length) {
                    throw new Error('请配置子集');
                }
                this.tableData.forEach(i => {
                    if (!i.sourceKey) {
                        throw new Error('源字段不能为空');
                    }
                    if (!i.sourceName) {
                        throw new Error('源字段名称不能为空');
                    }
                    if (!i.sourceType) {
                        throw new Error('源字段类型不能为空');
                    }
                    if (!i.targetDatabase) {
                        throw new Error('目标库名不能为空');
                    }
                    if (!i.targetTable) {
                        throw new Error('目标表名不能为空');
                    }
                    if (!i.targetValue) {
                        throw new Error('目标字段不能为空');
                    }
                    if (!i.targetType) {
                        throw new Error('目标字段类型不能为空');
                    }
                    if (!i.sortNum) {
                        throw new Error('界面排序不能为空');
                    }
                    if (!i.displayType) {
                        throw new Error('显示类型不能为空');
                    }
                    i.mapping.forEach(j => {
                        if (!j.sourceKey) {
                            throw new Error('源字段不能为空');
                        }
                        if (!j.sourceName) {
                            throw new Error('源字段名称不能为空');
                        }
                        if (!j.sourceType) {
                            throw new Error('源字段类型不能为空');
                        }
                        if (!j.targetDatabase) {
                            throw new Error('目标库名不能为空');
                        }
                        if (!j.targetTable) {
                            throw new Error('目标表名不能为空');
                        }
                        if (!j.targetValue) {
                            throw new Error('目标字段不能为空');
                        }
                        if (!j.targetType) {
                            throw new Error('目标字段类型不能为空');
                        }
                        if (!j.sortNum) {
                            throw new Error('界面排序不能为空');
                        }
                        if (!j.displayType) {
                            throw new Error('显示类型不能为空');
                        }
                    })
                })
            } catch (error) {
                this.$message.error(error.message);
                return false;
            }
            return true;

        },
        getFunctionList() {
            let self = this;
            self.fullscreenLoading = true;
            let req = {
                pageIndex: 1,
                pageSize: -1,
            }
            self.api.postJson(`/${serverConfig.msConfigureService}/function/list`, req).then((res) => {
                self.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    self.functionList = res.data.data.records;

                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
        getDetail() {
            if (!this.$route.query.guid) return;
            this.api.postJson(`/${serverConfig.msConfigureService}/platform/mf-params-mapping/listParamsMappingByFuncConfigGuid?funcConfigGuid=${this.$route.query.guid}`).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    let tableData = [];
                    let data = res.data.data;
                    data.forEach((item, index) => {
                        tableData.push({
                            "guid": item.guid,
                            "sourceKey": item.sourceKey,//源字段或主键
                            "sourceName": item.sourceName,//源字段名称
                            "sourceType": item.sourceType,//源字段类型
                            "targetType": item.targetType,//目标字段类型
                            "targetTable": item.targetTable,//目标表名
                            "targetValue": item.targetValue,//目标字段
                            "targetDatabase": item.targetDatabase,//目标库名
                            "keyFlag": item.keyFlag,//是否主键
                            "sortNum": item.sortNum,//界面排序
                            "groupFlag": item.groupFlag,//是否组名
                            "displayFlag": item.displayFlag,//是否展示
                            "dictGuid": item.dictGuid,//字典表guid,
                            "displayType": item.displayType,//显示类型
                            "mapping": JSON.parse(item.mapping),
                            "sourceTypeList": this.sourceTypeList,
                            "isRoot": true,
                            "index": index + 1,
                        })
                    })
                    tableData.forEach((m, n) => {
                        m.mapping.forEach(i => {
                            i.sourceTypeList = this.targetTypeList
                            i.isRoot = false,
                                i.index = n + 1,
                                i.guid = this.generateUUID();
                        })
                    })
                    this.tableData = tableData;

                } else {
                    self.$message.error(res.data.msg);
                }
            });
        }

    }
};
</script> 